import * as THREE from "three";
import { LineMaterial } from 'three/addons/lines/LineMaterial.js';
import { LineSegments2 } from 'three/addons/lines/LineSegments2.js';
import { LineSegmentsGeometry } from 'three/addons/lines/LineSegmentsGeometry.js';
import { COLORS } from "../Global/materials";

// Class for building Zoom In and Zoom Out buttons as 3D objects
export default class ZoomButtons extends THREE.Object3D {
    constructor() {
        super();      // Inherit from THREE.Object3D
        this._build(); // Initialize and construct the buttons
    }

    // Builds and positions zoom in and zoom out buttons
    _build() {
        const zoomIn = this._zoomIn();                // Create zoom in button
        zoomIn.position.set(8, -39, 0);               // Position zoom in button
        this.add(zoomIn);                             // Add zoom in button to parent object

        const zoomOut = this._zoomOut();              // Create zoom out button
        zoomOut.position.set(-8, -39, 0);             // Position zoom out button
        this.add(zoomOut);                            // Add zoom out button to parent object
    }

    // Creates zoom in button with a square background and plus symbol
    _zoomIn() {
        const zoomIn = new THREE.Object3D();          // Container for zoom in elements
        zoomIn.add(this._button("in"));               // Add base button mesh with name "in"
        zoomIn.add(this._line([-3, 0, 0, 3, 0, 0]));   // Horizontal line of plus sign
        zoomIn.add(this._line([0, -3, 0, 0, 3, 0]));   // Vertical line of plus sign
        return zoomIn;
    }

    // Creates zoom out button with a square background and minus symbol
    _zoomOut() {
        const zoomOut = new THREE.Object3D();         // Container for zoom out elements
        zoomOut.add(this._button("out"));             // Add base button mesh with name "out"
        zoomOut.add(this._line([-3, 0, 0, 3, 0, 0]));  // Only a horizontal line for minus sign
        return zoomOut;
    }

    // Creates a square clickable plane with a given name
    _button(name) {
        const geo = new THREE.PlaneGeometry(14, 14);            // Square plane geometry
        const mat = new THREE.MeshBasicMaterial({ color: COLORS.white }); // White color
        const button = new THREE.Mesh(geo, mat);                // Create mesh from geometry and material
        button.name = name;                                     // Assign name ("in" or "out") for interaction detection
        return button;
    }

    // Creates a thick 2D line using advanced line geometry
    _line(points) {
        const geo = new LineSegmentsGeometry();                 // Special geometry for line segments
        geo.setPositions(points);                               // Set line vertices from array
        const mat = new LineMaterial({ color: COLORS.black, linewidth: 2 }); // Set line color and thickness
        const line = new LineSegments2(geo, mat);               // Use enhanced line renderer
        return line;
    }
}
